import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import ContextModelClip from '../components/ContextModelClip';

const ContextModel = () => {
  return (
    <section id="context-model" className="bg-neutral-950 text-white scroll-mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <p className="text-[13px] uppercase tracking-[0.18em] text-neutral-400">The Context Model</p>
            <h2 className="mt-3 text-[32px] sm:text-[40px] lg:text-[56px] leading-[1.04] sm:leading-[1.02] tracking-[-0.02em] font-semibold">
              The missing piece of your <span className="italic font-light text-neutral-300">Enterprise AI stack</span>
            </h2>
            <p className="mt-6 text-[16px] text-neutral-300 leading-relaxed max-w-lg">
              Enterprise AI has blind spots when it comes to how your business operates. The MetaxuOne Context Model combines end-to-end process data, business knowledge, and intelligence — so your people and agents have the operational clarity they need to reason correctly, decide sensibly, and act reliably.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <Button asChild className="h-12 px-6 rounded-full bg-white text-neutral-900 hover:bg-neutral-200 text-[14px] font-medium inline-flex items-center gap-2" data-testid="context-go-platform-btn">
                <Link to="/platform">Go to the platform <ArrowRight className="w-4 h-4" /></Link>
              </Button>
            </div>
          </div>
          <div className="lg:col-span-7">
            <ContextModelClip />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContextModel;
